const DATE_UNITS = {
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1,
};
export function getUnitAndValueDate(secondsElapsed) {
  const entries = Object.entries(DATE_UNITS);
  for (const [unit, secondsInUnit] of entries) {
    let secondsUnit = secondsInUnit as number;
    const match = secondsElapsed >= secondsInUnit || unit === 'second';
    if (match) {
      const value = Math.floor(secondsElapsed / secondsUnit) * -1;
      return { value, unit };
    }
  }
}

export function getSecondsDiff(timestamp) {
  const newDate = (Date.now() - timestamp) / 1000;
  return newDate;
}
